// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"39c2840a","94":"bb4c66ac","118":"d52a84de","318":"5d8cd185","347":"8e1860cc","438":"2c07e9a9","453":"24b22d37","541":"fbe29b2f","546":"6978a30b","600":"09dbd8a5","651":"4e89e7c5","805":"ab724e54","943":"3d5ebd69"}[chunkId] + ".chunk.js";
};